import  angular from 'angular';
import dependencies from  './dependencies';

const MODULE_NAME = 'buscador.core';

const ngModule=angular.module(MODULE_NAME, [
    dependencies
]);


export default MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/core/index.js